import { createContext, useState, useContext, useEffect } from 'react'
import http from '@/lib/axios'

const SidebarContext = createContext()

export const useSidebar = () => useContext(SidebarContext)

export const SidebarProvider = ({ children }) => {
  const [menu, setMenu] = useState([])

  useEffect(() => {
    http.post('/app/aiCategory/getTreeList', {}).then((res) => {
      const newMenu = [
        {
          name: 'IT推荐',
          id: 'itrec',
          icon: '/assets/imgs/rec.svg',
          activeIcon: '/assets/imgs/rec_active.svg',
        },
        {
          name: '歌家自研AI',
          id: 'selfAI',
          icon: '/assets/imgs/goelia_ai.svg',
          activeIcon: '/assets/imgs/goelia_ai_active.svg',
        },
        {
          name: '我的导航',
          id: 'myNav',
          icon: '/assets/imgs/nav.svg',
          activeIcon: '/assets/imgs/my_nav.svg',
        },
      ]
      setMenu([...newMenu, ...res])
    })
  }, [])

  return (
    <SidebarContext.Provider value={{ menu }}>
      {children}
    </SidebarContext.Provider>
  )
}
